const PASSCODE_SESSION_KEY = 'wp:passcode-session';
const PASSCODE_FORCE_RESET_KEY = 'wp:passcode-force-reset';
const PASSCODE_FAILED_ATTEMPTS_KEY = 'wp:passcode-failed-attempts';

export const getSession = () => {
  const session = localStorage.getItem(PASSCODE_SESSION_KEY);

  if (session) {
    try {
      return JSON.parse(session);
    } catch (error) {
      return;
    }
  }
};

export const isPasscodeSessionValid = () =>
  getSession() && getSession().timestamp + 1000 * 60 * 60 * 12 > Date.now();

export const createPasscodeSession = (name: string, email: string) => {
  const newSession = {
    name,
    email,
    timestamp: Date.now(),
  };
  localStorage.setItem(PASSCODE_SESSION_KEY, JSON.stringify(newSession));
  return newSession;
};

export const clearPasscodeSession = () => {
  localStorage.removeItem(PASSCODE_SESSION_KEY);
};

export const hasForcePasscodeReset = () => {
  return localStorage.getItem(PASSCODE_FORCE_RESET_KEY) === 'true';
};

export const forcePasscodeReset = () => {
  localStorage.setItem(PASSCODE_FORCE_RESET_KEY, 'true');
};

export const clearForcePasscodeReset = () => {
  localStorage.removeItem(PASSCODE_FORCE_RESET_KEY);
};

export const getFailedPasscodeLoginAttempts = () => {
  const attempts = localStorage.getItem(PASSCODE_FAILED_ATTEMPTS_KEY);
  return attempts !== null && !isNaN(Number(attempts)) ? Number(attempts) : 0;
};

export const incrementFailedPasscodeLoginAttempts = () => {
  const newAttempts = getFailedPasscodeLoginAttempts() + 1;
  localStorage.setItem(PASSCODE_FAILED_ATTEMPTS_KEY, newAttempts.toString());
  return newAttempts;
};

export const clearFailedPasscodeLoginAttempts = () => {
  localStorage.removeItem(PASSCODE_FAILED_ATTEMPTS_KEY);
};
